import { textContainerStyle } from "@modules/Text/styles";
import { ThemeUIStyleObject } from "theme-ui";

export const containerStyles: ThemeUIStyleObject = {
  pt: 11,
  color: "darkGreen",
};
export const blockquoteWrapStyles: ThemeUIStyleObject = {
  color: "darkGreen",
};
export const blockquoteStyles: ThemeUIStyleObject = {
  pt: 3,
  color: "currentColor",
  fontFamily: "heading",
  fontSize: ["h3", "h2", "h1"],
  lineHeight: "tight",
  position: "relative",
  "&:before": {
    content: "'“'",
    position: "absolute",
    left: 0,
    top: 0,
    fontSize: ["60px", "80px", "120px"],
    lineHeight: 0,
    fontFamily: "heading",
    color: "currentColor",
  },
};
export const blockquoteCiteStyles: ThemeUIStyleObject = {
  fontFamily: "heading",
  fontSize: ["paragraphMedium", "h3", "h4"],
  color: "currentColor",
  mb: 0,
};

export const containerSpecialStyles: ThemeUIStyleObject = {
  ...textContainerStyle,
  color: "darkGreen",
};
export const blockquoteWrapSpecialStyles: ThemeUIStyleObject = {
  color: "darkGreen",
  textAlign: "center",
  backgroundColor: "rgba(0,0,0,0.2)",
  pt: [8, 10, 12],
  pb: [10, 8, 6],
  px: [4, 6, 8],
};
export const blockquoteTitleSpecialStyles: ThemeUIStyleObject = {
  color: "currentColor",
  fontFamily: "heading",
  fontSize: ["paragraphMedium", "paragraphMedium", "paragraph"],
  mb: [8, 10, 12],
};
export const blockquoteSpecialStyles: ThemeUIStyleObject = {
  color: "currentColor",
  fontFamily: "heading",
  fontSize: ["64px", "78px", "120px"],
  mb: [8, 10, 12],
};
export const blockquoteCiteSpecialStyles: ThemeUIStyleObject = {
  fontFamily: "body",
  fontSize: ["paragraphSmall", "paragraphSmall", "paragraphMedium"],
  color: "currentColor",
  width: ["100%", "50%", "65%"],
  display: "inline-block",
  textAlign: "center",
  my: 0,
};
